import { ICurrentUser, IReadOptions } from '@samc/common';
import { PageListCachedDataSource } from './BaseDataSources';
import { IUserData } from '@samc/taskmanagement-ui';

export class UserSource extends PageListCachedDataSource<ICurrentUser> {
  public constructor() {
    super('/datasource/users');
  }
}

export class UserDataSource extends PageListCachedDataSource<IUserData> {
  public constructor() {
    super('/datasource/users');
  }

  public async loadData(options: IReadOptions, abortController: AbortController): Promise<IUserData[]> {
    // The data from the server is ICurrentUser, but we need to map it to IUserData
    const data: ICurrentUser[] = (await super.loadData(options, abortController)) as any[];

    return data.map(user => ({
      username: user.name,
      email: user.email
    } as IUserData));
  }
}